import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SchedulesRovoConfigProviderEntrypointProps } from './SchedulesRovoConfigProvider.entrypoint.types.tsx';

type SchedulesRovoConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	SchedulesRovoConfigProviderEntrypointProps,
	{} | null
>;

export const schedulesRovoConfigProviderEntrypoint: EntryPoint<
	SchedulesRovoConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<SchedulesRovoConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-schedules-provider" */ './SchedulesRovoConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
